import { CHCBackToTop } from "./back-to-top.component.js";
customElements.define("chc-back-to-top", CHCBackToTop);
export {
  CHCBackToTop
};
//# sourceMappingURL=back-to-top.js.map
